/*
  rima atelier · bead colour (made to order)
  Two modes, both rendered by snippets/rima-beads.liquid:
  - choice: pill radiogroup that writes the chosen bead colour into the hidden
    line-item property (properties[Beads]) and the visible label.
  - match: nothing to choose. The beads follow the fabric, so the dot and the
    shade name mirror the colour swatch picked above (rima:colour-change from
    rima-colour.js). The property keeps its constant value; the shade itself is
    already on the order as properties[Colour].
  Progressive enhancement, vanilla ES. Without js the server-rendered default
  still submits.
*/
(function () {
  'use strict';

  function initChoice(root) {
    var input = root.querySelector('[data-beads-input]');
    var label = root.querySelector('[data-beads-selected]');
    var options = Array.prototype.slice.call(root.querySelectorAll('.rima-beads__option'));
    if (!options.length) return;

    function choose(btn, focus) {
      options.forEach(function (o) {
        o.classList.remove('is-selected');
        o.setAttribute('aria-checked', 'false');
        o.tabIndex = -1;
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-checked', 'true');
      btn.tabIndex = 0;
      var value = btn.getAttribute('data-bead-value');
      if (input) input.value = value;
      if (label) label.textContent = value;
      if (focus) btn.focus();
    }

    options.forEach(function (btn, i) {
      btn.tabIndex = btn.classList.contains('is-selected') ? 0 : -1;
      btn.addEventListener('click', function () { choose(btn); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          choose(options[(i + 1) % options.length], true);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          choose(options[(i - 1 + options.length) % options.length], true);
        }
      });
    });
  }

  function initMatch(root) {
    var dot = root.querySelector('[data-beads-dot]');
    var shade = root.querySelector('[data-beads-shade]');

    function sync() {
      var picked = document.querySelector('.rima-colour .rima-colour__swatch.is-selected');
      if (!picked) return;
      var src = picked.querySelector('.rima-colour__dot');
      if (dot && src) {
        // colour and image separately: the computed shorthand is not reliable
        // across browsers, and the As Photographed swatches use gradients.
        var cs = getComputedStyle(src);
        dot.style.backgroundColor = cs.backgroundColor;
        dot.style.backgroundImage = cs.backgroundImage;
      }
      // "Rosewater (No. 6)" reads as "Rosewater"; "As Photographed (Black)" as "Black".
      var value = picked.getAttribute('data-colour-value') || picked.getAttribute('title') || '';
      var name = value.replace(/^As Photographed\s*\((.*)\)$/, '$1').replace(/\s*\([^)]*\)\s*$/, '');
      if (shade && name) shade.textContent = 'Matched to ' + name;
    }

    sync();
    document.addEventListener('rima:colour-change', sync);
  }

  function boot() {
    document.querySelectorAll('[data-rima-beads]').forEach(function (root) {
      var mode = root.getAttribute('data-rima-beads');
      if (mode === 'choice') initChoice(root);
      else if (mode === 'match') initMatch(root);
    });
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();
